var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.09936 8.17461C4.97804 8.06273 4.81446 8 4.64403 8C4.4736 8 4.31003 8.06273 4.1887 8.17461C4.12894 8.22963 4.08148 8.29521 4.04908 8.36753C4.01668 8.43986 4 8.51748 4 8.59589C4 8.6743 4.01668 8.75192 4.04908 8.82424C4.08148 8.89657 4.12894 8.96215 4.1887 9.01716L11.5447 15.8254C11.666 15.9373 11.8296 16 12 16C12.1704 16 12.334 15.9373 12.4553 15.8254L19.8113 9.01716C19.8711 8.96215 19.9185 8.89657 19.9509 8.82424C19.9833 8.75192 20 8.67429 20 8.59589C20 8.51748 19.9833 8.43986 19.9509 8.36753C19.9185 8.29521 19.8711 8.22963 19.8113 8.17461C19.69 8.06273 19.5264 8 19.356 8C19.1855 8 19.022 8.06273 18.9006 8.17461L11.9995 14.3838L5.09936 8.17461Z",
    fill: "white",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.40802f05c9b7272ae043dea0ed826105.svg";
export { ForwardRef as ReactComponent };